// extracted by mini-css-extract-plugin
module.exports = {"notesListContainer":"UserPublicReflectionsList_notesListContainer__PeF9F","emptyNotesContainer":"UserPublicReflectionsList_emptyNotesContainer__o30hX"};